import React from 'react';

import Image from './image.jsx';
import Video from './video.jsx';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/media.d.ts').Media}
 */
const Media = ({
    image,
    imageComponent = Image,
    video,
    videoComponent = Video,
    videoEmbed,
    videoEmbedComponent = Video
}) => {
    let Component;
    let props;

    if (videoEmbed) {
        Component = videoEmbedComponent;
        props = videoEmbed;
    } else if (video) {
        Component = videoComponent;
        props = video;
    } else if (image) {
        Component = imageComponent;
        props = image;
    }

    return (
        <Component {...props} />
    );
};

/* ========================================================================= */
/* Export(s) */
/* ========================================================================= */

export default Media;
